import { render, staticRenderFns } from "./TrashBase.vue?vue&type=template&id=a0a24cf4"
import script from "./TrashBase.vue?vue&type=script&lang=js"
export * from "./TrashBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports